var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Mutation } from '../../mutation/Mutation';
import { memoize } from '../../../utils/mobx/decorators/memoize';
export class EntityMutation {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get entity() {
        return this.parent;
    }
    get mutationRegistry() {
        return this.entity.mutability;
    }
    get allObjectKeys() {
        return Object.getOwnPropertyNames(this.mutationRegistry.constructor.prototype);
    }
    get whenObjectKeys() {
        return this.allObjectKeys.filter(s => s.includes('_when'));
    }
    findActionForWhen(whenKey) {
        const [prefix] = whenKey.split('_');
        return this.allObjectKeys.find(key => key.startsWith(prefix) && key !== whenKey);
    }
    get whenActionKeyPairs() {
        return this.whenObjectKeys.map(key => [key, this.findActionForWhen(key)]);
    }
    get activeMutations() {
        return this.whenActionKeyPairs.map(([whenKey, actionKey]) => new Mutation({
            mutationCondition: () => this.mutationRegistry[whenKey],
            mutationAction: this.mutationRegistry[actionKey],
            entity: this.entity
        }));
    }
}
__decorate([
    memoize
], EntityMutation.prototype, "allObjectKeys", null);
__decorate([
    memoize
], EntityMutation.prototype, "whenObjectKeys", null);
__decorate([
    memoize
], EntityMutation.prototype, "whenActionKeyPairs", null);
__decorate([
    memoize
], EntityMutation.prototype, "activeMutations", null);
